import { render, staticRenderFns } from "./ShowAddressContactDlg.vue?vue&type=template&id=19d3a323"
import script from "./ShowAddressContactDlg.vue?vue&type=script&lang=js"
export * from "./ShowAddressContactDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports